import React from 'react';
import styled from 'styled-components';
import { space, layout } from 'styled-system';

const Wrapper = styled('svg').withConfig({
  shouldForwardProp: (prop) => !['width'].includes(prop),
})`
  width: 16px;

  ${layout}
  ${space}
`;

function Notification({ style }) {
  return (
    <Wrapper {...style} viewBox="0 0 16 19" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2303 13.9092H4.13027V8.05918C4.13027 5.80918 5.93027 4.00918 8.18027 4.00918C10.4303 4.00918 12.2303 5.80918 12.2303 8.05918V13.9092ZM14.0303 13.0092V8.05918C14.0303 5.29618 12.1043 2.98318 9.53027 2.37118V1.75918C9.53027 1.0136 8.92586 0.40918 8.18027 0.40918C7.43469 0.40918 6.83027 1.0136 6.83027 1.75918V2.37118C4.24727 2.98318 2.33027 5.29618 2.33027 8.05918V13.0092L0.530273 14.8092V15.7092H15.8303V14.8092L14.0303 13.0092ZM8.18027 18.4092C9.17439 18.4092 9.98027 17.6033 9.98027 16.6092H6.38027C6.38027 17.6033 7.18616 18.4092 8.18027 18.4092Z"
        fill="currentColor"
      />
    </Wrapper>
  );
}

export default Notification;
